import {createDraftSafeSelector} from '@reduxjs/toolkit';

const selectAuthState = (state) => state.auth;

export const selectIsAuthorized = createDraftSafeSelector(selectAuthState, (state) => state.isAuthorized);

export const selectFirstName = createDraftSafeSelector(selectAuthState, (state) => state.firstName);

export const selectLastName = createDraftSafeSelector(selectAuthState, (state) => state.lastName);

export const selectUserName = createDraftSafeSelector(selectAuthState, (state) => state.userName);

export const selectUserId = createDraftSafeSelector(selectAuthState, (state) => state.userId);

export const selectAuthTime = createDraftSafeSelector(selectAuthState, (state) => state.authTime);

export const selectUserRoles = createDraftSafeSelector(selectAuthState, (state) => state.userRoles);

export const selectUserGroups = createDraftSafeSelector(selectAuthState, (state) => state.userGroups);

export const selectUserChannel = createDraftSafeSelector(selectAuthState, (state) => state.userChannel);

export const selectUserLocationId = createDraftSafeSelector(selectAuthState, (state) => state.locationId);
